// extracted by mini-css-extract-plugin
module.exports = {"clientName":"FHIRClientsList_clientName_3L2CP"};